import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiHeart, FiShoppingCart } from 'react-icons/fi';
import { useShopping } from '../context/ShoppingContext';
import '../styles/ProductCard.css';

import { getImageUrl } from '../utils/imageUtils';

const ProductCard = ({ product, hideActions = false }) => {
  const { addToCart, addToWishlist, wishlistItems } = useShopping();
  const [isAdded, setIsAdded] = useState(false);
  const isInWishlist = wishlistItems.some((item) => item.id === product.id);
  const isOutOfStock = product.stockQuantity !== undefined && product.stockQuantity <= 0;

  const handleAddToCart = () => {
    addToCart(product);
    setIsAdded(true);
    setTimeout(() => setIsAdded(false), 2000);
  };

  const handleWishlist = () => {
    addToWishlist(product);
  };

  const FALLBACK_IMG =
    'data:image/svg+xml;utf8,' +
    encodeURIComponent(
      `<svg xmlns="http://www.w3.org/2000/svg" width="600" height="800" viewBox="0 0 600 800">
        <rect width="100%" height="100%" fill="#f0f0f0"/>
        <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="#bdbdbd" font-size="28" font-family="Arial, Helvetica, sans-serif">Image</text>
      </svg>`
    );

  return (
    <div className="product-card">
      <Link to={`/product/${product.id}`} className="product-image-container">
        <img
          src={getImageUrl(product.images && product.images.length > 0 ? product.images[0] : product.image)}
          alt={product.name}
          className="product-image"
          onError={(e) => {
            if (e.currentTarget.dataset.fallback !== '1') {
              e.currentTarget.src = FALLBACK_IMG;
              e.currentTarget.dataset.fallback = '1';
            }
          }}
        />
        {product.discount && <span className="discount-badge">{product.discount}% OFF</span>}
        {product.originalPrice && !product.discount && (
          <span className="discount-badge">
            {Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100)}% OFF
          </span>
        )}
      </Link>

      <div className="product-info">
        <p className="product-category">{product.category}</p>
        <Link to={`/product/${product.id}`} className="product-name">
          <h3>{product.name}</h3>
        </Link>

        <p className="product-seller">by {product.brand || product.seller}</p>

        <div className="product-rating">
          <span className="stars">{product.rating || 4.3} ★</span>
          <span className="reviews">({product.reviews || Math.floor(Math.random() * 1000) + 100})</span>
        </div>

        <div className="product-price">
          <span className="current-price">₹{product.price.toLocaleString('en-IN')}</span>
          {product.originalPrice && (
            <span className="original-price">₹{product.originalPrice.toLocaleString('en-IN')}</span>
          )}
        </div>

        {!hideActions && (
          <div className="product-actions">
            <button
              className={`add-to-cart-btn ${isAdded ? 'added' : ''}`}
              onClick={handleAddToCart}
              disabled={isOutOfStock}
              aria-label={isOutOfStock ? 'Out of stock' : (isAdded ? 'Added to cart' : 'Add to cart')}
              title={isOutOfStock ? 'Out of stock' : (isAdded ? 'Added to cart' : 'Add to cart')}
              style={isOutOfStock ? { opacity: 0.6, cursor: 'not-allowed', backgroundColor: '#ccc' } : {}}
            >
              <FiShoppingCart />
              {isOutOfStock ? (
                <span className="label-full">Out of Stock</span>
              ) : isAdded ? (
                'Added!'
              ) : (
                <>
                  <span className="label-full">Add to Cart</span>
                  <span className="label-short">Add</span>
                </>
              )}
            </button>
            <button
              className={`wishlist-btn ${isInWishlist ? 'active' : ''}`}
              onClick={handleWishlist}
            >
              <FiHeart fill={isInWishlist ? 'currentColor' : 'none'} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductCard;
